import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import NewSegment from './NewSegment';


const ShipmentMadeFaster = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 1,
  });

  return (
    <Container className='intersection-animate'>
      <SegmentedArea>
        <NewSegment />
      </SegmentedArea>
      <Img src='/static/img/world.png' />
    </Container>
  );
};

export default ShipmentMadeFaster;

const Container = styled.div`
  margin: 0 -5.4375rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: ${({ theme }) => theme.palette.offWhite};

  &.animate {
    --ydist: 100%;

    & > * > * > *:first-of-type {
      animation-name: move, show;
      animation-delay: 0.5s;
      animation-duration: 0.5s;
      animation-fill-mode: backwards;
    }

    & > * > * > *:last-of-type > * > * > *:nth-of-type(1) {
      --ydist: 50%;
      animation-name: move, show;
      animation-delay: 0.7s;
      animation-duration: 0.5s;
      animation-fill-mode: backwards;
    }

    & > * > * > *:last-of-type > * > * > *:nth-of-type(2) {
      --ydist: 150%;
      animation-name: move, show;
      animation-delay: 0.9s;
      animation-duration: 0.5s;
      animation-fill-mode: backwards;
    }

    @keyframes move {
      from {
        transform: translateY(var(--ydist));
      }
      to {
        transform: 0;
      }
    }

    @keyframes show {
      from {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column;
    justify-content: left;
    gap: 72px;
    width: 100vw;
    margin: 0;
    margin-left: -24px;

    & > * {
      margin: 0px !important;
      padding: 0 24px;
    }

    & > * ~ * {
      margin: 0px;
      padding: 0;
    }
  }
`;

const SegmentedArea = styled.div`
  margin-top: 136px;
  margin-bottom: 136px;
  margin-left: 5.4375rem;
  display: flex;

  @media (max-width: 884px) {
    padding-top: 67px;
  }
`;

const Img = styled.img``;
